export default __webpack_public_path__ + "static/media/screen3.582e487d.png";